import React from 'react';

const SvgUs = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="US_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="US_svg__e">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F0F0F0" offset="100%" />
      </linearGradient>
      <path
        d="M2 2.667a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm2.667 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm2.666 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm2.667 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zM3.333 4a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM6 4a.667.667 0 1 1 0-1.333A.667.667 0 0 1 6 4zm2.667 0a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM10 5.333A.667.667 0 1 1 10 4a.667.667 0 0 1 0 1.333zm-2.667 0a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm-2.666 0a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM2 5.333A.667.667 0 1 1 2 4a.667.667 0 0 1 0 1.333zm1.333 1.334a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm2.667 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zm2.667 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zM10 8a.667.667 0 1 1 0-1.333A.667.667 0 0 1 10 8zM7.333 8a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM4.667 8a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zM2 8a.667.667 0 1 1 0-1.333A.667.667 0 0 1 2 8z"
        id="US_svg__d"
      />
      <filter
        x="-5.4%"
        y="-7.5%"
        width="110.7%"
        height="130%"
        filterUnits="objectBoundingBox"
        id="US_svg__c"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="US_svg__b" fill="#fff">
        <use xlinkHref="#US_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#US_svg__a" />
      <path
        d="M0 0h28v1.333H0V0zm0 2.667h28V4H0V2.667zm0 2.666h28v1.334H0V5.333zM0 8h28v1.333H0V8zm0 2.667h28V12H0v-1.333zm0 2.666h28v1.334H0v-1.334zM0 16h28v1.333H0V16zm0 2.667h28V20H0v-1.333z"
        fill="#D02F44"
        mask="url(#US_svg__b)"
      />
      <path fill="#46467F" mask="url(#US_svg__b)" d="M0 0h12v9.333H0z" />
      <g mask="url(#US_svg__b)">
        <use fill="#000" filter="url(#US_svg__c)" xlinkHref="#US_svg__d" />
        <use fill="url(#US_svg__e)" xlinkHref="#US_svg__d" />
      </g>
    </g>
  </svg>
);

export default SvgUs;
